module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', [_c('p', {
    staticClass: "OT"
  }, [_vm._v("Contents")]), _vm._v(" "), _c('p', {
    staticClass: "CON2",
    attrs: {
      "id": "toc1"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/DeGroat_Toughest_People_to_Love_text2#toc_marker-2"
    }
  }, [_vm._v("Introduction")])]), _vm._v(" "), _c('p', {
    staticClass: "CON1",
    attrs: {
      "id": "toc2"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/DeGroat_Toughest_People_to_Love_text3#toc_marker-3"
    }
  }, [_vm._v("Part 1: Understanding People")])]), _vm._v(" "), _c('p', {
    staticClass: "CON2",
    attrs: {
      "id": "toc3"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/DeGroat_Toughest_People_to_Love_text4#toc_marker-4"
    }
  }, [_vm._v("1. A vision for those we lead, a vision for ourselves")])]), _vm._v(" "), _c('p', {
    staticClass: "CON2",
    attrs: {
      "id": "toc4"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/DeGroat_Toughest_People_to_Love_text5#toc_marker-5"
    }
  }, [_vm._v("2. Understanding our story")])]), _vm._v(" "), _c('p', {
    staticClass: "CON1",
    attrs: {
      "id": "toc5"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/DeGroat_Toughest_People_to_Love_text6#toc_marker-6"
    }
  }, [_vm._v("Part 2: Leading and Loving Difficult People")])]), _vm._v(" "), _c('p', {
    staticClass: "CON2",
    attrs: {
      "id": "toc6"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/DeGroat_Toughest_People_to_Love_text7#toc_marker-7"
    }
  }, [_vm._v("3. Personality disorders: loving those who drive you crazy")])]), _vm._v(" "), _c('p', {
    staticClass: "CON2",
    attrs: {
      "id": "toc7"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/DeGroat_Toughest_People_to_Love_text8#toc_marker-8"
    }
  }, [_vm._v("4. Addictions: loving in the dark")])]), _vm._v(" "), _c('p', {
    staticClass: "CON2",
    attrs: {
      "id": "toc8"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/DeGroat_Toughest_People_to_Love_text9#toc_marker-9"
    }
  }, [_vm._v("5. Loving the fool:when relationships turn ugly")])]), _vm._v(" "), _c('p', {
    staticClass: "CON1",
    attrs: {
      "id": "toc9"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/DeGroat_Toughest_People_to_Love_text10#toc_marker-10"
    }
  }, [_vm._v("Part 3: Dealing with Ourselves: The Best Help We Can Give Another")])]), _vm._v(" "), _c('p', {
    staticClass: "CON2",
    attrs: {
      "id": "toc10"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/DeGroat_Toughest_People_to_Love_text11#toc_marker-11"
    }
  }, [_vm._v("6. Growing through pain:the gift of the dark")])]), _vm._v(" "), _c('p', {
    staticClass: "CON2",
    attrs: {
      "id": "toc11"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/DeGroat_Toughest_People_to_Love_text12#toc_marker-12"
    }
  }, [_vm._v("7. Living with wholeness:rest and resiliency in the leader’s life")])]), _vm._v(" "), _c('p', {
    staticClass: "CON2",
    attrs: {
      "id": "toc12"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/DeGroat_Toughest_People_to_Love_text13#toc_marker-13"
    }
  }, [_vm._v("8. Growing into leadership maturity:self-­care and the art of shadow-­boxing")])]), _vm._v(" "), _c('p', {
    staticClass: "CON2",
    attrs: {
      "id": "toc13"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/DeGroat_Toughest_People_to_Love_text14#toc_marker-14"
    }
  }, [_vm._v("Benediction")])]), _vm._v(" "), _c('p', {
    staticClass: "CON2",
    attrs: {
      "id": "toc14"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/DeGroat_Toughest_People_to_Love_text15#toc_marker-15"
    }
  }, [_vm._v("Notes")])]), _vm._v(" "), _c('p', {
    staticClass: "CON2",
    attrs: {
      "id": "toc15"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/DeGroat_Toughest_People_to_Love_text16#toc_marker-16"
    }
  }, [_vm._v("Resources")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5c88c418","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/DeGroat_Toughest_People_to_Love_text-1.vue
// module id = 63
// module chunks = 0